<template>
  <div
    class="transactions mt-30 bg-white mb-144 pt-57 pl-30 pr-30"
    v-if="transactions"
  >
    <div class="transactions__ttl-wrapper flex between">
      <h2 class="f-21 bold">
        {{ _.get(contentData, "conf.header.title") }}
      </h2>
      <div class="flex al-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.901"
          height="20"
          viewBox="0 0 20.901 20"
          :class="{ disabled: to_cash }"
        >
          <path
            id="Path_9191"
            data-name="Path 9191"
            d="M11.031,17.476a1.248,1.248,0,0,0-1.162,0L5.347,19.854a1.25,1.25,0,0,1-1.813-1.317L4.4,13.5a1.251,1.251,0,0,0-.36-1.106L.378,8.828A1.25,1.25,0,0,1,1.072,6.7l5.056-.735a1.25,1.25,0,0,0,.941-.684L9.329.7a1.25,1.25,0,0,1,2.242,0l2.261,4.582a1.25,1.25,0,0,0,.941.684l5.056.735a1.25,1.25,0,0,1,.694,2.131l-3.659,3.566A1.251,1.251,0,0,0,16.5,13.5l.863,5.036a1.25,1.25,0,0,1-1.813,1.317Z"
            fill="#ffcb05"
            fill-rule="evenodd"
          />
        </svg>

        <el-switch
          v-model="to_cash"
          active-color="#28AD25"
          inactive-color="#28AD25"
          class="ml-13 mr-13"
        >
        </el-switch>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.821"
          height="18"
          viewBox="0 0 14.821 18"
          :class="{ disabled: !to_cash }"
        >
          <g
            id="Group_8717"
            data-name="Group 8717"
            transform="translate(-746.812 -118.547)"
          >
            <path
              id="Path_8888"
              data-name="Path 8888"
              d="M751.916,132.005a4.609,4.609,0,0,0,3.669,1.554h4.781l-.406,2.988H748.032l.118-2.558,2.368-.215a6.478,6.478,0,0,1-3.707-6.311,7.165,7.165,0,0,1,1.447-4.446,7.059,7.059,0,0,1,3.86-2.582v-1.888h1.673v1.625a5.289,5.289,0,0,1,.6-.024h.479v-1.6h1.672v1.841a6.124,6.124,0,0,1,3.753,2.594,9.691,9.691,0,0,1,1.339,5.462h-3.49q0-3.824-1.6-5.068v5.068h-1.672v-5.689a3.989,3.989,0,0,0-.5-.024,5.2,5.2,0,0,0-.575.024v5.689h-1.673V123.4q-1.554,1.2-1.555,4.446A6.118,6.118,0,0,0,751.916,132.005Z"
              transform="translate(0)"
              fill="#1a1a1a"
            />
          </g>
        </svg>
      </div>
    </div>
    <div class="transactions__bar-wrapper flex column" v-if="to_cash">
      <TransactionBar
        v-for="(item, idx) in financial_array"
        :key="idx"
        :to_cash="to_cash"
        :transaction="item"
      />
    </div>
    <div class="transactions__bar-wrapper flex column" v-else>
      <TransactionBar
        v-for="(item, idx) in transactions"
        :key="idx"
        :to_cash="to_cash"
        :transaction="item"
      />
    </div>
    <div
      class="
        transactions__load-more
        flex
        justify-center
        al-center
        pointer
        pt-30
        pb-30
      "
      v-if="transactions.length < rowCount"
      @click="show_more()"
      :class="{ 'ev-none': disableButton }"
    >
      <span class="f-16 pangram-extrabold mr-10">{{
        $fn.tr("მეტის ჩვენება")
      }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="7.857"
        viewBox="0 0 10 7.857"
      >
        <path
          id="Icon_material-play-arrow"
          data-name="Icon material-play-arrow"
          d="M12,7.5v10l7.857-5Z"
          transform="translate(17.5 -12) rotate(90)"
          fill="#1a1a1a"
        />
      </svg>
    </div>
    <div
      class="transactions__scroll-top pointer"
      @click="to_top()"
      v-if="windowWidth >= 1366"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        viewBox="0 0 70 70"
      >
        <g
          id="Group_8821"
          data-name="Group 8821"
          transform="translate(-1723 -2368)"
        >
          <circle
            id="Ellipse_459"
            data-name="Ellipse 459"
            cx="35"
            cy="35"
            r="35"
            transform="translate(1723 2368)"
            fill="#e6e6e6"
          />
          <g id="arrow-up-1" transform="translate(1751 2399)">
            <path
              id="Path_10103"
              data-name="Path 10103"
              d="M16.673,14.951a.772.772,0,0,1-.571-.258L10.839,8.961a.747.747,0,0,0-1.119,0L4.458,14.694a.761.761,0,0,1-1.142,0,.936.936,0,0,1,0-1.243L8.579,7.718a2.271,2.271,0,0,1,3.4,0l5.263,5.733a.936.936,0,0,1,0,1.243A.772.772,0,0,1,16.673,14.951Z"
              transform="translate(-3.08 -6.951)"
              fill="#1a1a1a"
            />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import TransactionBar from "@/components/modules/cabinet/TransactionBar";
import resize_handler from "@/mixins/resize_handler";
import getCardData from "@/mixins/getCardData";
export default {
  props: {
    contentData: Object
  },
  components: {
    TransactionBar
  },
  mixins: [resize_handler, getCardData],
  data() {
    return {
      to_cash: true,
      points_array: [],
      financial_array: [],
      page: 1,
      page_size: 10,
      disableButton: false
    };
  },
  computed: {
    transactions() {
      return this.$store.state.main.cache?.unicardTransactions?.data;
    },
    rowCount() {
      return this.$store.state.main.cache?.unicardTransactions?.rowCount;
    }
  },
  methods: {
    to_top() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },

    show_more() {
      this.disableButton = true;
      this.page += 1;
      this.getTransactions(this.page, this.page_size);
    },

    "$store.state.main.cache?.unicardTransactions?.data"(ns) {
      console.log(ns);
      this.disableButton = false;
    }
  },
  watch: {
    transactions: {
      immediate: true,
      handler(ns, os) {
        console.log(ns, "first ns");
        if (ns.length) {
          let arr = ns.filter(tran => tran.amount !== 0);
          this.financial_array = arr;
          console.log(ns);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.smart-components-wrapper.cabinet {
  overflow: visible;
  @media (max-width: 1365px) {
    overflow: hidden;
    width: 56.97167755991286%;
  }
  @media (max-width: 1023px) {
    width: 100%;
  }
}
.transactions {
  width: 962px;
  position: relative;
  overflow: visible;

  &__ttl-wrapper {
    svg path {
      transition: 0.4s;
    }
    svg.disabled {
      path {
        fill: #b9b9b9;
      }
    }
  }
  &__load-more {
    span,
    svg path {
      transition: 0.4s;
    }

    @include hover {
      span {
        color: $red;
      }
      svg path {
        fill: $red;
      }
    }
  }

  &__scroll-top {
    position: absolute;
    bottom: 0;
    right: -30px;
    transform: translateX(100%);
    cricle,
    path {
      transition: 0.4s;
    }
    @include hover {
      circle {
        fill: #4d4d4f;
      }
      path {
        fill: white;
      }
    }
  }
  @media (max-width: 1919px) {
    &__scroll-top {
      right: initial;
      left: -30px;
      transform: translateX(-100%);
    }
  }
  @media (max-width: 1550px) {
    width: 770px;
  }
  @media (max-width: 1440px) {
    width: 621px;
  }
  @media (max-width: 1439px) {
    width: 714px;
  }
  @media (max-width: 1365px) {
    width: 100%;
  }
  @media (max-width: 1023px) {
    margin-bottom: 89px;
  }
  @media (max-width: 767px) {
    padding-left: 13px;
    padding-right: 13px;
  }
  @media (max-width: 413px) {
    &__ttl-wrapper {
      flex-direction: column;
      justify-content: initial;
      align-items: center;
      h2 {
        text-align: center;
        margin-bottom: 21px;
      }
    }
  }
}
</style>
